/**
 * sessionStorage keys holding booking-flow state, dropped once a duplicated tab runs under
 * another sub-session. Add new booking-flow keys here. Tracking, attribution and preference
 * keys must survive a duplicate, so they are not listed.
 */
export const SALES_PROCESS_KEYS: readonly string[] = [
  'IBE-SalesProcess',
  'selectedTripSelectionKey',
  'currentSearchData',
  'dbfPath',
  'discountCode',
  'discountCodeAmount',
  'CreatingOrder',
  'hasRecentPostBookingOrder',
  'postbookingProducts',
  'cartData',
  'traveler-details',
  'travelArrangerFirstName',
  'travelArrangerLastName',
  'taxIdInput',
  'persuasionModalSelectionKey',
  'persuasionModalBrandedFaresSelectionKey',
  'brandedFareOffered',
  'brandedFarePersuasionModalShown',
  'brandedFarePersuasionModalUpgradeSelected',
  'recommendedFareKey',
  'manuallyRemovedProductIds',
  'manuallyAddedProductIds',
  'mbWayStartTime',
  'payNowStartTime',
  'upiStartTime',
  'pix-start-time',
  'slc',
  'hasPaymentFailed',
  'CFCRedirectUrl',
  'showSeatMapStep',
];

/** Families of keys whose names are built at runtime. */
export const SALES_PROCESS_KEY_PREFIXES: readonly string[] = [
  // products/src/common/utils/constants.ts FORM_PREFIX: `form-session-data-<form>`
  'form-session-data-',
];

export const isSalesProcessKey = (key: string): boolean =>
  SALES_PROCESS_KEYS.includes(key) ||
  SALES_PROCESS_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
